import { Component, EventEmitter, Input, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Provider, ProviderWarehouse } from 'src/typings';
import { ProviderWarehouseService } from '../provider-warehouse.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class ProviderWarehouseCreateComponent {
  @Input() set wh(payload: ProviderWarehouse | undefined) {
    this._wh = payload;
    if (!payload) return;
    this.providerControl.setValue(payload.provider || this.provider);
    this.cityControl.setValue(payload.city);
    this.whForm.controls.description.setValue(payload.description);
  }

  @Input() set provider(payload: Provider | undefined) {
    this._provider = payload;
    if (payload) this.providerControl.setValue(payload);
  }

  private _provider: Provider | undefined;

  private _wh: ProviderWarehouse | undefined;

  get wh() {
    return this._wh;
  }

  get provider() {
    return this._provider;
  }

  doneEvent: EventEmitter<ProviderWarehouse> = new EventEmitter();

  whForm = this.fb.group({
    description: new UntypedFormControl(),
    city: new UntypedFormControl(),
    provider: new UntypedFormControl()
  });

  get providerControl() {
    return this.whForm.controls.provider as UntypedFormControl;
  }

  get cityControl() {
    return this.whForm.controls.city as UntypedFormControl;
  }

  constructor(
    private providerWarehouseService: ProviderWarehouseService,
    private fb: UntypedFormBuilder,
    @Optional() private dialogRef?: MatDialogRef<ProviderWarehouseCreateComponent>
  ) {}

  saving = false;
  error = '';
  get canSave() {
    const value = this.whForm.value;
    return !!String(value.description || '').trim() && !!value.provider?.id && !!value.city?.id;
  }
  async save() {
    if (this.saving || !this.canSave) { this.whForm.markAllAsTouched(); return; }
    const value = this.whForm.value;
    const payload = { description: String(value.description).trim(), city_id: value.city.id, provider_id: value.provider.id };
    this.saving = true; this.error = '';
    this.whForm.disable({ emitEvent: false });
    if (this.dialogRef) this.dialogRef.disableClose = true;
    try {
      const result = await firstValueFrom(this.wh
        ? this.providerWarehouseService.update({ id: this.wh.id, ...payload })
        : this.providerWarehouseService.create(payload));
      this.doneEvent.emit(result);
    } catch { this.error = 'Не удалось сохранить склад. Проверьте данные и повторите.'; }
    finally { this.whForm.enable({ emitEvent: false }); this.saving = false; if (this.dialogRef) this.dialogRef.disableClose = false; }
  }
}
